<div id="content" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" id="slide1">
            <div id="carousel-1" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner" role="listbox">
                    <div class="item active">
                        <img src="./assets/images/domicilio-bogota-crop-u53189.jpg" alt="User Image">
                    </div>
                    <div class="item">
                        <img src="./assets/images/programa-domicilio-crop-u52829.jpg" alt="User Image">
                    </div>
                    <div class="item">
                        <img src="./assets/images/reparación-fuera-garantia-crop-u53009.jpg" alt="User Image">
                    </div>
                    <div class="item">
                        <img src="./assets/images/lab-woden-crop-u52103.jpg" alt="User Image">
                    </div>
                    <div class="item">
                        <img src="./assets/images/reparar-no-reemplazar-crop-u52649.jpg" alt="User Image">
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-xs-offset-3" id="logoWoden">
                <img src="./assets/images/logo-woden-pro-neg1-hd-u69940-fr.png" alt="">
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-xs-6 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-xs-offset-3 " id="slid2">
                <div id="carousel-2" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner" role="listbox">
                        <div class="item active">
                            <img src="./assets/images/domicilio320x320.png" alt="">
                        </div>
                        <div class="item">
                            <img src="./assets/images/seguimiento.png" alt="">
                        </div>
                        <div class="item">
                            <img src="./assets/images/tecnicos-partes-certificados328x328.png" alt="">
                        </div>
                        <div class="item">
                            <img src="./assets/images/colaboradores318x318.png" alt="">
                        </div>
                        <div class="item">
                            <img src="./assets/images/reparar-no-reemplzar.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div id="form">
                <div id="line"></div>
                <h2><strong style="font-size: 28px;">Completa el formulario</strong></h2>
                <h3>¡Te llamaremos para programar el servicio!</h3>
                <h3>Información del equipo a reparar</h3>
                <form #agendaForm="ngForm" name="agendaForm">
                    <div style="margin-bottom: 8px;">
                        <select #agm="ngModel" name="agm" [(ngModel)]="mark" id="" placeholder="Modelo" (change)="changeMarca()" required>
                            <option value="0">Marca (Obligatorio)</option>
                            <option *ngFor="let mr of listMarks" value={{mr.id}}>{{mr.name}}</option>
                        </select>
                    </div>
                    <div style="margin-bottom: 8px;">
                        <select #agmo="ngModel" name="agmo" [(ngModel)]="model" id="" placeholder="Modelo" [disabled]="!modeloValidate" required>
                            <option value="0">Modelo (Obligatorio)</option>
                            <option *ngFor="let md of listModels" value={{md.id}}>{{md.name}}</option>
                        </select>
                    </div>
                    <div style="margin-bottom: 8px;">
                        <select #agco="ngModel" name="agco" [(ngModel)]="concept" id="" placeholder="Modelo" required>
                            <option value="0">¿Tu equipo está en garantía?</option>
                            <option *ngFor="let cp of listConcepto" value={{cp.id}}>{{cp.name}}</option>
                        </select>
                    </div>
                    <h3>Información del domicilio</h3>
                    <div style="margin-bottom: 8px;">
                        <select #agci="ngModel" name="agci" [(ngModel)]="city" id="" placeholder="Modelo" required>
                            <option value="0">Ciudad (Obligatorio)</option>
                            <option *ngFor="let cd of listCities" value={{cd.id}}>{{cd.name}}</option>
                        </select>
                    </div>
                    <div style="margin-bottom: 8px;">
                        <input #agdir="ngModel" name="agdir" [(ngModel)]="agendaPro.address" type="text" placeholder="Dirección (Obligatorio)" required>
                    </div>
                    <h3>Información del contacto</h3>
                    <div style="margin-bottom: 8px;">
                        <input #agced="ngModel" name="agced" [(ngModel)]="identification" type="number" min="5" max="20" pattern="[0-9]{2,20}" placeholder="Cédula (Obligatorio)" required>
                        <span *ngIf="!agced.valid && agced.touched" class="label label-danger">El
                            campo es Invalido.</span>
                    </div>
                    <div style="margin-bottom: 8px;">
                        <input #agno="ngModel" name="agno" [(ngModel)]="agendaPro.name" type="text" placeholder="Nombre (Obligatorio)" required>
                    </div>
                    <div style="margin-bottom: 8px;">
                        <input #agem="ngModel" name="agem" [(ngModel)]="agendaPro.email" type="text" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" placeholder="Correo electrónico (Obligatorio)" required>
                        <span *ngIf="!agem.valid && agem.touched" class="label label-danger">Correo Invalido</span>
                    </div>
                    <div style="margin-bottom: 20px;">
                        <input #agpho="ngModel" name="agpho" [(ngModel)]="phone" type="number" min="7" max="20" pattern="[0-9]{2,20}" placeholder="Teléfono o Celular (Obligatorio)" required>
                        <span *ngIf="!agpho.valid && agpho.touched" class="label label-danger">El
                            campo es Invalido.</span>
                    </div>
                    <div>
                        <div style="margin-bottom: 8px;">
                            <input #agpt="ngModel" name="agpt" [(ngModel)]="agendaPro.aceptPolicy" type="checkbox" id="check" required>
                            <span class="act">
                                He leído y acepto la <a href="https://www.woden.com.co/politica-de-proteccion-de-datos"
                                    target="blank" style="color: #FF7700;">Política de Tratamiento de Datos</a> y los
                                <a href="https://www.woden.com.co/TYC-servicio-tecnico-domicilio" target="blank"
                                    id="terminos">Términos y Condiciones</a> (Obligatorio).</span>
                        </div>
                        <div style="margin-bottom: 40px;">
                            <input #agae="ngModel" name="agae" [(ngModel)]="agendaPro.aceptShipping" type="checkbox" id="check">
                            <span class="act" id="envio1">Autorizo a WODEN enviar contenido informativo, comercial y de
                                marketing a mi correo electrónico.</span>
                        </div>
                    </div>
                    <div style="margin-bottom: 8px;">
                        <button class="btn btn-block" style="background: #FF7700; color:white" (click)="createAgendaPro()">
                            <b *ngIf="!loading">Enviar</b>
                            <div *ngIf="loading" class="loadlog"></div>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="footer">
            <div class="col-md-8 col-md-offset-2">
                <h1 class="text-center"><strong>Recomendaciones</strong></h1>
                <h4 class="text-center" style="color: white;">Te ayudarán a que el proceso sea más fácil y rápido.</h4>
            </div>
            <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-1" style="margin-top: 40px;">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_no_garantia_poster_u20395.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Tu equipo no debe estar en garantía</h4>
                        <h6 class="text-center" style="color: white;">Si no estás seguro, llena el formulario y te ayudaremos a validar</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                    <div class="row margingbotton">
                        <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                            <div class="text-center">
                                <a href="https://www.woden.com.co/TYC-servicio-tecnico-domicilio" target="_blank" class="btn btn-link text-center" style="color: white; border: solid 1px white; border-radius: 15px; width: 120px;">Ver más</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_backup_poster_u20403.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Haz un backup de tu información</h4>
                        <h6 class="text-center" style="color: white;">Si no sabes cómo, nosotros te ayudamos, aquí o cuando te contactemos</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                    <div class="row margingbotton">
                        <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                            <div class="text-center">
                                <a href="https://www.woden.com.co/backup-servicio-tecnico" target="_blank" class="btn btn-link" style="color: white; border: solid 1px white; border-radius: 15px; width: 120px;">Ver más</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_segumiento_poster_u20411.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Haz seguimiento del proceso</h4>
                        <h6 class="text-center" style="color: white;">WhatApp, Email, SMS, Redes sociales, o desde nuestra Web ¡Tú eliges!</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                    <div class="row margingbotton">
                        <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                            <div class="text-center">
                                <a href="https://www.woden.com.co/opciones-de-seguimiento" target="_blank" class="btn btn-link" style="color: white; border: solid 1px white; border-radius: 15px; width: 120px;">Ver más</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_seguridad_poster_u20419.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Conoce los protocolos de seguridad</h4>
                        <h6 class="text-center" style="color: white;">Tu salud y seguridad son muy importantes para nosotros.</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                    <div class="row margingbotton">
                        <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                            <div class="text-center">
                                <a href="https://www.woden.com.co/protocolos-seguridad" target="_blank" id="protocolos" class="btn btn-link" style="color: white; border: solid 1px white; border-radius: 15px; width: 120px;">Ver más</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="footer1">
            <div class="col-md-8 col-md-offset-2">
                <h1 class="text-center" style="margin-top: 100px;color: #FF7700;"><strong>Somos Centro Autorizado de
                    Servicio</strong></h1>
                <h4 class="text-center">Estamos comprometidos con la calidad de nuestro servicio, de inicio a fin</h4>
            </div>
            <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-1" style="margin-top: 40px;">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_certificados_poster_u20565.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Técnicos certificados por el fabricante</h4>
                        <h6 class="text-center" style="color: #6E6E6E;">Personal experto en la marca de tu equipo</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_originales_poster_u20573.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Repuestos originales del fabricante</h4>
                        <h6 class="text-center" style="color: #6E6E6E;">Rendimiento y durabilidad que sólo partes originales te pueden dar</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_3_garantia_poster_u20581.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Garantía de 3 meses en la reparación</h4>
                        <h6 class="text-center" style="color: #6E6E6E;">Gestiona tus solicitudes de garantía posterior a la reparación a través de nuestros canales.</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-xs-offset-4">
                        <img src="./assets/images/icono_agentes_campo_woden_poster_u20589.png" alt="" style="width: 85px; margin-left: 0px;">
                    </div>
                    <div class="col-lg-12 col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                        <h4 class="text-center">Agentes de campo propios de Woden Colombia</h4>
                        <h6 class="text-center" style="color: #6E6E6E;">Nuestros agentes de campo cuentan con amplia experiencia en servicio</h6>
                    </div>
                    <div class="row spacebotton">
                        &nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="footer2">

            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <h3>Sobre Woden</h3>
                <p style="font-size: 10px; width: 90%;">
                    Somos aliados de negocios de marcas líderes en tecnología y comunicaciones a nivel mundial. Potenciamos el ciclo de vida útil de equipos tecnológicos usados, y ofrecemos a personas y empresas una amplia variedad de productos y servicios que hacen la vida
                    más fácil, generan ahorros y ayudan al medio ambiente.
                </p>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <h3 style="margin-left: 22px;">Accesos rápidos</h3>
                <ul style="font-size: 10px">
                    <li>Sitio Web Woden</li>
                    <li>Tienda online</li>
                    <li>Gestión de orden de servicio</li>
                    <li>Contacto</li>
                    <li>Servicio al cliente</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " id="footer3">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <p style="font-size: 10px;"><strong>WODEN COLOMBIA SAS.</strong> Todos los derechos reservados</p>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <p style="font-size: 10px;">Avenida calle 13 # 56 - 35 Bogotá, Colombia</p>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                <p style="font-size: 10px;">+57(1)355 8200</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 " id="footer4">

        </div>
    </div>
</div>